<script setup>
import { ref } from 'vue';
import PersonSection from './PersonSection.vue';
import OpportunitySection from './OpportunitySection.vue';

defineProps({
  conversationId: { type: [Number, String], required: true },
  contactName: { type: String, default: '' },
  contactEmail: { type: String, default: '' },
  contactPhone: { type: String, default: '' },
});

const personVersion = ref(0);
const onPersonChange = () => {
  personVersion.value += 1;
};
</script>

<template>
  <div class="flex flex-col gap-4 py-1 px-2 sm:px-0">
    <PersonSection
      :conversation-id="conversationId"
      :contact-name="contactName"
      :contact-email="contactEmail"
      :contact-phone="contactPhone"
      @linked="onPersonChange"
      @unlinked="onPersonChange"
    />
    <div class="border-t border-n-weak" />
    <OpportunitySection
      :key="personVersion"
      :conversation-id="conversationId"
    />
  </div>
</template>
